export function CanvasMod() {

    L.CanvasMod = L.Canvas.extend({
        // modified from leaflet to fire events for all clicked layers (Works with Leaflet 1.9.3)
        _onClick(e) {
            const point = this._map.mouseEventToLayerPoint(e);
            const clickedLayers = [];

            for (let order = this._drawFirst; order; order = order.next) {
                const layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === 'click' || e.type === 'preclick') || !this._map._draggableMoved(layer)) {
                        clickedLayers.unshift(layer);
                    }
                }
            }
            this._fireEvent(clickedLayers.length ? clickedLayers : false, e);
        }
    });

}
